import { ANALYZE_BARCODE_ACTION_TRIGGER, ANALYZE_BARCODE_SCAN } from 'b2b-apps/shop/analytics/redux';
import { TEALIUM_PROD_ACTION } from 'b2b-apps/shop/analytics/types/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { ProductTileType } from 'b2b-apps/shop/product/redux/products/tile/types';

const BARCODE_VALUE = 'barcode_scan';
const CATEGORY_SET_VALUE = 'nav';

interface AnalyticsEventDataProps {
  'component_category': string[];
  'component_subcategory': string[];
  'component_attribute3': string[];
  'component_location'?: string[] | undefined;
  'component_attribute1'?: string[] | null | undefined;
}

type AnalyticsEventDataType = AnalyticsEventDataProps | Record<any, any>;

interface BarcodeAnalyticsEventData {
  barcodeAction: TEALIUM_PROD_ACTION;
  barcode?: string;
  productTile?: RemoteRecord<ProductTileType>;
}

type AnalyzeBarcodeScanUsageAction = {
  type: typeof ANALYZE_BARCODE_SCAN | typeof ANALYZE_BARCODE_ACTION_TRIGGER;
  payload: {
    barcodeAction: TEALIUM_PROD_ACTION;
    barcode?: string;
    sku?: string;
  };
};

/* eslint-disable camelcase */
enum BARCODE_ACTIONS_VALUES {
  'open' = 'open',
  'camera_activation_success' = 'camera_activation_success',
  'camera_activation_error' = 'camera_activation_error',
  'add_list' = 'add_list',
  'product_found' = 'list',
  'product_not_found' = 'product_not_found',
  'list_click' = 'list_click',
  'watchlist_add' = 'wishlist_add',
}
/* eslint-enable camelcase */

type BarcodeActions = AnalyzeBarcodeScanUsageAction;

export type {
  AnalyticsEventDataProps,
  AnalyticsEventDataType,
  AnalyzeBarcodeScanUsageAction,
  BarcodeActions,
  BarcodeAnalyticsEventData,
};

export {
  BARCODE_ACTIONS_VALUES,
  BARCODE_VALUE,
  CATEGORY_SET_VALUE,
};
